import React, { useState, useEffect, useRef } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";

const ImageCarousel = ({ imagesInfo }) => {
  const [activeImage, setActiveImage] = useState(imagesInfo[0]);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const image = getImage(activeImage.image);
  const intervalId = useRef(null);

  const handleClick = (imageObj) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveImage(imageObj);
      setIsTransitioning(false);
    }, 300);
    clearInterval(intervalId.current);
    setUpInterval();
  };

  const setUpInterval = () => {
    intervalId.current = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveImage((prevImage) => {
          const currentIndex = imagesInfo.indexOf(prevImage);
          const nextIndex = (currentIndex + 1) % imagesInfo.length;
          return imagesInfo[nextIndex];
        });
        setIsTransitioning(false);
      }, 300);
    }, 4000);
  };

  useEffect(() => {
    setUpInterval();
    return () => {
      clearInterval(intervalId.current);
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center">
      {/* Image */}
      <div className="flex justify-center mt-4 w-full">
        <div className={classNames(
          "w-full flex items-center justify-center min-h-[200px] sm:min-h-[300px] md:min-h-[400px] transition-opacity duration-300",
          isTransitioning ? "opacity-0" : "opacity-100"
        )}>
          <div className="w-full border border-[#282844] rounded-lg overflow-hidden">
            <GatsbyImage image={image} alt={activeImage.name} />
          </div>
        </div>
      </div>

      {/* Navigation pill under the image */}
      <div className="mt-3 w-full flex justify-center px-2">
        <div className="bg-[#358cfd]/10 rounded-full p-1 overflow-x-auto">
          <div className="flex items-center gap-1">
            {imagesInfo.map((imageObj, index) => {
              const selected = activeImage.name === imageObj.name;
              return (
                <button
                  key={index}
                  onClick={() => handleClick(imageObj)}
                  className={classNames(
                    "h-8 px-2 md:px-2 rounded-full text-[14px] text-white whitespace-nowrap",
                    selected ? "bg-[#358cfd]/40" : "bg-transparent"
                  )}
                >
                  {imageObj.name}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;
